import { StyledMarkdown } from '@/components/styled/markdown';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
} from '@/graphql/fragment/form.public.fragment';
import { getComponentByType } from '@/components/types';
import { Typography } from '@mui/material';
import parse from 'html-react-parser';
import styles from '../dss.module.scss';

interface Props {
  focus: boolean;
  field: FormPublicFieldFragment;
  design: FormPublicDesignFragment;
  next: (values?: any) => void;
  prev: () => void;
  slideIndex: number;
  lastSlideIndex: number;
  // this has to be passed into the component from swiper since we only reset the question's form
  // if the user wants to make another submission in the end page
  //    if we reset form here, it will lose the user's input upon them moving onto the next question
  // formik will automatically reset the form upon seeing it's intialValues change
  // in this case, a flag that tells the form to reset
  submissionCount?: number;
  //added
  totalQuestions: number;
  values: any;
  errors: any;
  handleChange: (ChangeEvent: any) => void;
}

/**
 * @param input email input
 * @returns if the input is an email
 */
export const isEmail = (input: string): boolean => {
  let emailRE =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRE.test(input);
};

export const CustomField: React.FC<Props> = ({
  field,
  design,
  submissionCount,
  handleChange,
  values,
  errors,
}) => {
  const FieldInput = getComponentByType(field.type);

  return (
    <>
      <Typography
        sx={{ typography: { sm: 'h4', xs: 'h5' } }}
        style={{ color: design.colors.question }}
        className={styles.input}
      >
        {parse(field.title)}{' '}
      </Typography>
      {field.description ? (
        <StyledMarkdown
          className='question-description'
          design={design}
          type={'question'}
        >
          {field.description}
        </StyledMarkdown>
      ) : undefined}

      {FieldInput && (
        <FieldInput
          design={design}
          field={field}
          onChange={handleChange}
          value={values[field.id] || ''}
          error={errors[field.id]}
          helperText={errors[field.id]}
          submissionCount={submissionCount}
        />
      )}
    </>
  );
};
